module.exports = __webpack_public_path__ + "img/apple-iphone-12-pro-max.ef3a9d8d.png";